module.exports = __webpack_public_path__ + "media/images/logo_rev-f0039734955c33b166e54d39f87a8ee6.png";